import { CSSTransition } from 'react-transition-group';
import { useEffectOnce } from 'react-use';
import { Layouts } from '~/shared';
import { Controls } from '../../components/Controls';
import { Filters } from '../../components/Filters';
import { Grid } from '../../components/Grid';
{
	/* import { Logo } from '../../components/Logo'; */
}
import { VerticalFormat } from '../../components/VerticalFormat';
import { useLayoutDispatch, useLayoutSelector } from '../../redux/hooks';
import { resetStore } from '../../redux/wrappers';
import { StyledContainer, StyledInterfaceContainer } from './PhotoMode.styled';

const PhotoMode: React.FC = () => {
	const dispatch = useLayoutDispatch();
	const grid = useLayoutSelector((state) => state.photoMode.grid);
	const format = useLayoutSelector((state) => state.photoMode.format);
	const interfaceHidden = useLayoutSelector(
		(state) => state.photoMode.interfaceHidden,
	);

	useEffectOnce(() => {
		return () => {
			dispatch(resetStore());
		};
	});

	return (
		<StyledContainer className={Layouts.PhotoMode}>
			{format === 'vertical' && <VerticalFormat />}
			{/* <Logo /> */}
			<CSSTransition
				in={interfaceHidden}
				timeout={500}
				classNames={'interface'}
			>
				<StyledInterfaceContainer>
					<CSSTransition in={grid} timeout={500} classNames={'grid'}>
						<Grid />
					</CSSTransition>
					<Filters />
					<Controls />
				</StyledInterfaceContainer>
			</CSSTransition>
		</StyledContainer>
	);
};

export { PhotoMode };
